(function(){
  // Minimal theme message/toast system. Safe text only (uses innerText).
  const CONTAINER_ID = 'site-messages';
  function ensureContainer(){
    let container = document.getElementById(CONTAINER_ID);
    if(!container){
      container = document.createElement('div');
      container.id = CONTAINER_ID;
      container.setAttribute('aria-live','polite');
      container.style.position = 'fixed';
      container.style.left = '0';
      container.style.right = '0';
      container.style.top = '10px';
      container.style.display = 'flex';
      container.style.justifyContent = 'center';
      container.style.pointerEvents = 'none';
      container.style.zIndex = '9999';
      // ensure minimal CSS exists when we actually need to show messages
      if(!document.getElementById('theme-message-styles')){
        const style = document.createElement('style');
        style.id = 'theme-message-styles';
        style.innerHTML = '\n.theme-message { font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial; }\n';
        document.head.appendChild(style);
      }

      document.body.appendChild(container);
    }
    return container;
  }

  function createEl(type, text){
    const el = document.createElement('div');
    el.className = 'theme-message theme-message-' + type;
    el.style.pointerEvents = 'auto';
    el.style.background = '#fff';
    el.style.padding = '8px 12px';
    el.style.borderRadius = '4px';
    el.style.boxShadow = '0 6px 18px rgba(0,0,0,0.12)';
    el.style.color = '#333';
    el.style.maxWidth = '920px';
    el.style.margin = '6px';
    el.style.fontSize = '14px';
    el.style.lineHeight = '20px';
    el.innerText = text || '';
    return el;
  }

  function showMessage(type, text, duration){
    const container = ensureContainer();
    const el = createEl(type, text == null ? '' : String(text));

    // simple color variants
    switch(type){
      case 'error':
        el.style.borderLeft = '4px solid #f4615c';
        break;
      case 'success':
        el.style.borderLeft = '4px solid #52c41a';
        break;
      case 'info':
        el.style.borderLeft = '4px solid #1890ff';
        break;
      case 'warning':
        el.style.borderLeft = '4px solid #faad14';
        break;
      default:
        el.style.borderLeft = '4px solid transparent';
    }

    container.appendChild(el);
    // animate in
    el.style.transform = 'translateY(-10px)';
    el.style.opacity = '0';
    el.style.transition = 'transform .18s ease, opacity .18s ease';
    requestAnimationFrame(()=>{
      el.style.transform = 'translateY(0)';
      el.style.opacity = '1';
    });

    const time = typeof duration === 'number' ? duration : (duration ? parseInt(duration,10) || 3000 : 3000);
    if(time > 0){
      setTimeout(()=>{
        // animate out
        el.style.transform = 'translateY(-10px)';
        el.style.opacity = '0';
        setTimeout(()=>{ el.remove(); }, 220);
      }, time);
    }
    return el;
  }

  window.ThemeMessage = {
    error: function(text, duration){ return showMessage('error', text, duration); },
    success: function(text, duration){ return showMessage('success', text, duration); },
    info: function(text, duration){ return showMessage('info', text, duration); },
    warning: function(text, duration){ return showMessage('warning', text, duration); },
    show: function(opts){
      if(typeof opts === 'string') return showMessage('info', opts);
      if(!opts) return null;
      return showMessage(opts.type || 'info', opts.text || '', opts.duration);
    }
  };

  // small helper: keep backwards compatibility if someone expects window.XyMessage to exist
  // but don't override an existing XyMessage.
  if(!window.XyMessage){
    window.XyMessage = {
      error: function(text,duration){ return window.ThemeMessage.error(text,duration); },
      success: function(text,duration){ return window.ThemeMessage.success(text,duration); },
      info: function(text,duration){ return window.ThemeMessage.info(text,duration); },
      warning: function(text,duration){ return window.ThemeMessage.warning(text,duration); },
      show: function(opts){ return window.ThemeMessage.show(opts); }
    }
  }

  // NOTE: styles are injected lazily in `ensureContainer()` so loading this
  // script does not alter the DOM until a message is shown.
})();
